// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"folder-unlocked"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M15.999 16.5H22.999V21H15.999V16.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 20H2V3.5H9L11 6H22V9","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M17.25 16.5V14.75C17.25 13.5074 18.2574 12.5 19.5 12.5C20.1188 12.5 20.6793 12.7498 21.0861 13.1541M15.999 16.5H22.999V21H15.999V16.5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-folder-unlocked')
export default class FolderUnlockedIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'folder-unlocked',
    }
  }
}
